module.exports = __webpack_public_path__ + "img/alka_seltzer_plus_powermax_severe.5681e4d1.png";